import { Style, ThreeDots } from "react-loader-spinner";

interface Props {
  height?: number;
  width?: number;
  wrapperStyle?: Style;
  wrapperClass?: string;
  color?: string;
}
const DefaultNTILoader: React.FC<Props> = ({
  height,
  width,
  wrapperStyle,
  wrapperClass,
  color = "#000"
}) => (
  <ThreeDots
    wrapperStyle={wrapperStyle}
    wrapperClass={wrapperClass}
    color={color}
    height={height ?? 20}
    width={width ?? 20}
  />
);

export default DefaultNTILoader;
